import * as React from "react";
import CustomerOnboardingEditionScreen from "../../customer_onboarding/edition/CustomerOnboardingEditionScreen";

function AuthorizationCustomerOnboardingScreen({taxpayerIdentificationNumber}) {
    return <CustomerOnboardingEditionScreen taxpayerIdentificationNumber={taxpayerIdentificationNumber} showWorkflowButtons={false}/>;
}

export default AuthorizationCustomerOnboardingScreen;

